<div class="flex-1"></div>
<oui-loading></oui-loading>
<div class="flex-1"></div>
